











import { Component, Vue, Prop } from 'vue-property-decorator';
import MenuItem from '@pjn/core/model/app/MenuItem';
import ToolbarInlineMenuItem from './ToolbarInlineMenuItem.vue';

/**
 * Menu de Toolbar inline (no extendida)
 */
@Component({ components: { ToolbarInlineMenuItem } })
export default class ToolbarInlineMenu extends Vue {

  /** Items del menu */
  @Prop({ type: Array, default: () => [] })
  items: MenuItem[];

  /** Item seleccionado del menu */
  @Prop({ required: false }) selected: MenuItem | null;

  onItemClick(item: MenuItem) {
    this.$emit('itemClick', item);
  }
}
